export const DRAFT_REASON = {
    NEW_ITEM: 'NewItem',
    CHANGE_ITEM: 'ChangeItem',
    CHANGE_ITEM_WITH_BIDS: 'ChangeItemWithBids',
    COPY_OTHER_MEMBERS_ITEM: 'CopyOtherMembersItem',
    COPY_OWN_ITEM: 'CopyOwnItem',
    SELL_SIMILAR_ITEM: 'SellSimilarItem',
    RESTART_ITEM: 'RestartItem'
};

export const ITEM_TYPE = {
    BIN: 'bin',
    AUCTION: 'auction',
    AUCTION_AND_BIN: 'auction_and_bin'
};

// Clothes, Accessories, Shoes
const CSA_CATEGORY_IDS = [16, 1612, 1623];

export const PURE_BIN_CATEGORY_IDS = [...CSA_CATEGORY_IDS];
